import { React } from 'react';
import Slider from "react-slick";

import './Agenda.css';

import Agenda1 from '../../assets/images/agenda/agenda1.jpeg';
import Agenda2 from '../../assets/images/agenda/agenda2.jpeg';
import Agenda3 from '../../assets/images/agenda/agenda3.jpeg';
import Agenda4 from '../../assets/images/agenda/agenda4.jpeg';
import ArrowRight from '../../assets/icons/arrow-right.svg';

const agenda = [
  {
    id: 1,
    type: 'Spotlight',
    title: 'Official Kickoff Cocktail',
    description: 'We’re hosting a special cocktail hour at 5pm on Monday, Aug 7 to kick things off! Make sure to arrive early enough to catch this opening event & start making connections.',
    photo: Agenda1,
  },
  {
    id: 2,
    type: 'Spotlight',
    title: 'Main Stage Keynote – Featuring Open AI',
    description: 'We’re proud to welcome Che Chang, Deputy General Council of Open AI, to our main stage! Don’t miss our fireside chat-style talk with Che on Wednesday, August 9th at 8:30am.',
    photo: Agenda2,
  },
  {
    id: 3,
    type: 'Spotlight',
    title: 'America’s Largest Hotel – The MGM Grand',
    description: 'The MGM Grand, located in the heart of Vegas on the Las Vegas Strip, features a casino, four outdoor pools, a lazy river, and several world renowned restaurants including Morimoto, Joël Robuchon, and more.',
    photo: Agenda3,
  },
  {
    id: 4,
    type: 'Spotlight',
    title: 'Daily Happy Hours',
    description: 'Relax & unwind! Both Tuesday and Wednesday evening, after the conference content ends, we’re hosting a happy hour on the exhibit floor featuring a different specialty cocktail each day.',
    photo: Agenda4,
  },
];

function Agenda() {
  const settings = {
    dots: true,
    infinite: false,
    className: "slider variable-width",
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    variableHeight: true,
    customPaging: i => (
      <div
        className="agenda-item-pagination-dot"
      >
      </div>
    )
  };

  return (
    <Slider {...settings}>
      {
        agenda.map(agendum => (
          <div className="agendum" key={agendum.id}>
            <img src={agendum.photo} alt="Agendum" className="agendum-image" />
            <div className="agendum-content">
              <div className="agendum-type">
                <div>
                  <span>{agendum.type}</span>
                </div>
              </div>
              <h3>{agendum.title}</h3>
              <p className="body-16">{agendum.description}</p>
            </div>
            <img src={ArrowRight} alt="Arrow right" className="arrow-right" />
          </div>
        ))
      }
    </Slider>
  );
}

export default Agenda;
